import { useQuery } from "react-query";
import { getBonusQReport } from "../requests/getBonusQReport";

export default function useGetBonusQReport({ param }: { param: string }) {
  return useQuery({
    queryKey: ["getBonusQReport", param],
    queryFn: () => getBonusQReport(param),
    enabled: true,
  });
}
